<template>
  <div id="app">
    <router-view :accountData="accountData" @loginSucces="loginSucces" @logout="logout" />
  </div>
</template>

<script>
var hours = 0.01; // Reset when storage is more than (1=60mins)(0.1=6mins)
var now = new Date().getTime();
var setupTime = localStorage.getItem('_Idiomtalent_SetupTime');
if (setupTime == null) {
  localStorage.setItem('_Idiomtalent_SetupTime', now)
} else {
  if (now - setupTime > hours * 60 * 60 * 1000) {
    // localStorage.clear()
    localStorage.removeItem("_IdiomtalentAudio");
    localStorage.removeItem("_IdiomtalentModels");
    localStorage.removeItem("_IdiomtalentTestimonial");
    localStorage.setItem('_Idiomtalent_SetupTime', now);
  }
}

export default {
  name: 'App',
  data() {
    return {
      accountData: {},
      input: {},
      file: [],
    }
  },
  // created() {
  //   this.checkForRedirect(); // use this when not using -> mode: 'history'
  // },
  // mounted(){
  //   this.accountData = this.LocalStorage("mindAtnelatmoidi");
  // },
  methods: {
    checkForRedirect() {
      const [baseURL, firstPathPart] = this.extractUrlParts();
      window.location.href = `${baseURL}#/${firstPathPart}`;
    },
    extractUrlParts() {
      const baseURL = window.location.origin;
      const fullPath = window.location.pathname;
      const pathParts = fullPath.split('/').filter(part => part.length > 0);
      const firstPathPart = pathParts[0] || '';

      return [baseURL, firstPathPart];
    },
    loginSucces(data) {
      let accountData = new Object();
      accountData = {
        i: data.id,
        u: data.username,
        c: data.password,
        n: data.name,
        img: data.img,
        t: data.admin_type_id,
      }
      this.accountData = accountData;
      localStorage.setItem("mindAtnelatmoidi", JSON.stringify(accountData));
    },
    checkLogin() {
      console.log("$route", this.$route.name, this.accountData);
      // if(this.accountData.i){
      //   if(this.accountData.cd==true){
      //       this.redirect('/company');
      //   }else if(this.accountData.cd==false){
      //       this.redirect('/talent');
      //   }else{
      //       this.redirect('/');
      //   }
      // }else{
      //   this.redirect('/');
      // }
    },
    redirect(path) {
      if (this.$route.path !== path) this.$router.push(path)
    },
    logout() {
      localStorage.removeItem("ataDtnuocca");
      this.accountData = {};
      this.redirect('/admin')
    },
  },
  watch: {
    $route() {
      // if(this.$route.path!==path) this.$router.push(path)
    },
  }
}
</script>

<style media="screen">
.pointer {
  cursor: pointer !important;
}

.swal-modal .swal-text {
  text-align: center !important;
}

.swal-modal .swal-footer {
  text-align: center !important;
}

@import url(//fonts.googleapis.com/css?family=Raleway:300);
@import url(//fonts.googleapis.com/css?family=Open+Sans);

#app {
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  color: #3e4855;
  background-color: #fff;
  line-height: 1.42857143;
}

.btn-idiom {
  color: #fff !important;
  background-color: #aa4d8e !important;
}

.btn-round {
  border-radius: 25px !important;
}

.font-idiom {
  color: #aa4d8e !important;
}
</style>
